export default __webpack_public_path__ + "static/media/arrow.e38833e2.svg";